import { useEffect, useState } from "react";
import { StyleSheet, useWindowDimensions } from "react-native";
import CurrencyInput from "react-native-currency-input";

import { useLanguage } from "../../hooks";

import { Colors, RegularExpressions } from "../../constants";

import { useForm, Controller } from "react-hook-form";
import { FluidView, Field, RequiredIcon } from "../UI";
import { StyledSelect, StyledSwitch } from "../UI/Styled";
import FormTextInput from "./FormTextInput";
import FormButton from "./FormButton";
import FormAdditionals from "./FormAdditionals";

const FromCortina = (props) => {
    const { isLoading, additionals, setAdditionals } = props;
    const isActive = props.isActive != undefined ? props.isActive == 0 : true;
    const inCalculator = props.inCalculator ?? false;

    const [showFolds, setShowFolds] = useState(false);
    const [totalAdditional, setTotalAdditional] = useState(0);

    const layout = useWindowDimensions();
    const isMobile = layout.width < 768;

    const { translate } = useLanguage();

    const INSTALLATIONS_CHOICES = [
        { id: 0, label: translate("word", "WALL"), value: 0 },
        { id: 1, label: translate("word", "CEILING"), value: 1 },
    ];
    const CONTROL_SIDE_CHOICES = [
        { id: 0, label: "--", value: 0 },
        { id: 1, label: translate("word", "LEFT"), value: 1 },
        { id: 2, label: translate("word", "RIGHT"), value: 2 },
        { id: 3, label: translate("word", "RIGHTLEFT"), value: 3 },
    ];
    const TEJIDO_CHOICES = [
        { id: 0, label: "Blackout", value: 0 },
        { id: 1, label: "Transparentes", value: 1 },
        { id: 2, label: "Traslucido", value: 2 },
    ];

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
        setValue,
        setError: setErrorForm,
        clearErrors,
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            quantity: props.data?.quantity ?? 1,
            confection: props.data?.confection ?? "",
            consumption: props.data?.consumption ?? "",
            model: props.data?.model ?? "",
            color: props.data?.color ?? "",
            roll_width: props.data?.roll_width ?? "",
            heigth: props.data?.heigth ?? "",
            area: props.data?.area ?? "",
            bastillas: props.data?.bastillas ?? "",
            width: props.data?.width ?? "",
            cost: props.data?.cost ?? 0,
            total_width: props.data?.total_width ?? "",
            total_heigth: props.data?.total_heigth ?? "",
            folds: props.data?.folds ?? 0,
            unit_cost: props.data?.unit_cost ?? 0,
            notes: props.data?.notes ?? "",
            total_cost: props.data?.total_cost ?? "",

            type_installation: props.data?.type_installation ?? 0,
            control_heigth: props.data?.control_heigth ?? "",
            automation: props.data?.automation ?? false,
            control: props.data?.control ?? false,
            control_side: props.data?.control_side ?? 0,
            location: props.data?.location ?? "",
            tejido: props.data?.tejido ?? 0,
        },
    });

    useEffect(() => {
        var heigth = parseFloat(watch("heigth"));
        var bastillas = parseFloat(watch("bastillas"));
        heigth = isNaN(heigth) ? 0 : heigth;
        bastillas = isNaN(bastillas) ? 0 : bastillas;
        setValue("total_heigth", (heigth + bastillas).toFixed(2));
    }, [watch("heigth"), watch("bastillas")]);

    useEffect(() => {
        var consumption = parseFloat(watch("consumption"));
        var width = parseFloat(watch("width"));
        consumption = isNaN(consumption) ? 0 : consumption;
        width = isNaN(width) ? 0 : width;
        setValue("total_width", (consumption * width).toFixed(2));
    }, [watch("consumption"), watch("width")]);

    useEffect(() => {
        var total_heigth = parseFloat(watch("total_heigth"));
        var total_width = parseFloat(watch("total_width"));
        var roll_width = parseFloat(watch("roll_width"));
        var cost = parseFloat(watch("cost"));
        total_heigth = isNaN(total_heigth) ? 0 : total_heigth;
        total_width = isNaN(total_width) ? 0 : total_width;
        roll_width = isNaN(roll_width) ? 0 : roll_width;
        cost = isNaN(cost) ? 0 : cost;
        if (total_heigth <= roll_width) {
            setShowFolds(false);
            var totalCost = total_width * cost;
            var area = total_width;
            // setArea((area).toFixed(2));
            setValue("area", area.toFixed(2));
            setValue("unit_cost", totalCost.toFixed(2));
        } else {
            var folds = total_width / roll_width;
            folds = (folds % 1).toFixed(3) >= 0.05 ? Math.ceil(folds) : Math.floor(folds);
            var totalCost = total_heigth * folds * cost;
            var area = total_heigth * folds;
            setShowFolds(true);
            setValue("folds", folds);
            // setArea((area).toFixed(2));
            setValue("area", area.toFixed(2));
            setValue("unit_cost", totalCost.toFixed(2));
        }
    }, [watch("total_heigth"), watch("total_width"), watch("roll_width"), watch("cost")]);

    useEffect(() => {
        var unit_cost = parseFloat(watch("unit_cost"));
        var quantity = parseFloat(watch("quantity"));
        unit_cost = isNaN(unit_cost) ? 0 : unit_cost;
        quantity = isNaN(quantity) ? 0 : quantity;
        setValue("total_cost", (unit_cost * quantity + totalAdditional * quantity).toFixed(2));
    }, [watch("unit_cost"), watch("quantity"), totalAdditional]);

    return (
        <FluidView
            justifyContent="flex-start"
            alignItems="center"
            style={{ ...styles.container, ...StyleSheet.flatten(props.style) }}
        >
            <FluidView>
                <Controller
                    control={control}
                    name="quantity"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.quantity?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.quantity?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "QUANTITY")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.quantity ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.quantity ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="numeric"
                                style={styles.fromContainer}
                                placeholder={translate("word", "QUANTITY")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="confection"
                    rules={{ required: true }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.confection?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "CONFECTION")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.confection ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.confection ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                style={styles.fromContainer}
                                placeholder={translate("word", "CONFECTION")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="consumption"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.consumption?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.consumption?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : "Consumo por metro."
                            }
                            title={
                                <>
                                    {translate("word", "CONSUMPTION")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.consumption ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.consumption ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="decimal-pad"
                                style={styles.fromContainer}
                                placeholder={translate("word", "CONSUMPTION")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="model"
                    rules={{ required: true }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.model?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "MODEL")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.model ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.model ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                style={styles.fromContainer}
                                placeholder={translate("word", "MODEL")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="color"
                    rules={{ required: true }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.color?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "COLOR")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.color ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.color ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                style={styles.fromContainer}
                                placeholder={translate("word", "COLOR")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="roll_width"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.roll_width?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.roll_width?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "ROLL_WIDTH")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.roll_width ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.roll_width ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="decimal-pad"
                                style={styles.fromContainer}
                                placeholder={translate("word", "ROLL_WIDTH")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="width"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.width?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.width?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "WIDTH")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.width ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.width ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="decimal-pad"
                                style={styles.fromContainer}
                                placeholder={translate("word", "WIDTH")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="heigth"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.heigth?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.heigth?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "HEIGTH")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.heigth ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.heigth ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="decimal-pad"
                                style={styles.fromContainer}
                                placeholder={translate("word", "HEIGTH")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="bastillas"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.bastillas?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.bastillas?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "BASTILLAS")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.bastillas ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.bastillas ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="decimal-pad"
                                style={styles.fromContainer}
                                placeholder={translate("word", "BASTILLAS")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />

                <Controller
                    control={control}
                    name="automation"
                    rules={{ required: false }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.automation?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={translate("word", "AUTOMATION")}
                            labelColor={errors.automation ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <StyledSwitch
                                style={styles.checkBox}
                                disabled={!isActive}
                                value={value}
                                onValueChange={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="control"
                    rules={{ required: false }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.control?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={translate("word", "CONTROL")}
                            labelColor={errors.control ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <StyledSwitch
                                style={styles.checkBox}
                                disabled={!isActive}
                                value={value}
                                onValueChange={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="control_side"
                    rules={{ required: false }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.control_side?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={translate("word", "CONTROL_SIDE")}
                            labelColor={errors.control_side ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <StyledSelect
                                disabled={!isActive}
                                selectedValue={value}
                                onValueChange={(itemValue, itemIndex) => onChange(itemValue)}
                                data={CONTROL_SIDE_CHOICES}
                                style={styles.fromContainer}
                                textStyle={styles.fromContainerSelect}
                                textSize={isMobile ? 14 : 16}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="location"
                    rules={{ required: false }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.location?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={translate("word", "LOCATION")}
                            labelColor={errors.location ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.location ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                style={styles.fromContainer}
                                placeholder={translate("word", "LOCATION")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="tejido"
                    rules={{ required: false }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.tejido?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : ""
                            }
                            title={translate("word", "TEJIDO")}
                            labelColor={errors.tejido ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <StyledSelect
                                disabled={!isActive}
                                selectedValue={value}
                                onValueChange={(itemValue, itemIndex) => onChange(itemValue)}
                                data={TEJIDO_CHOICES}
                                style={styles.fromContainer}
                                textStyle={styles.fromContainerSelect}
                                textSize={isMobile ? 14 : 16}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="type_installation"
                    rules={{ required: false }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.type_installation?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.type_installation?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={translate("word", "TYPE_INSTALLATION")}
                            labelColor={errors.type_installation ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <StyledSelect
                                disabled={!isActive}
                                selectedValue={value}
                                onValueChange={(itemValue, itemIndex) => onChange(itemValue)}
                                data={INSTALLATIONS_CHOICES}
                                style={styles.fromContainer}
                                textStyle={styles.fromContainerSelect}
                                textSize={isMobile ? 14 : 16}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="control_heigth"
                    rules={{ required: false, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.control_heigth?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.control_heigth?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={translate("word", "CONTROL_HEIGTH")}
                            labelColor={errors.control_heigth ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.control_heigth ? "danger" : ""}
                                iconName={isActive?"edit":null}
                                iconType="FontAwesome"
                                disabled={!isActive}
                                returnKeyType="next"
                                autoCorrect={false}
                                autoCapitalize="none"
                                keyboardType="decimal-pad"
                                style={styles.fromContainer}
                                placeholder={translate("word", "CONTROL_HEIGTH")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />

                <Controller
                    control={control}
                    name="cost"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.cost?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.cost?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={
                                <>
                                    {translate("word", "COST")}
                                    <RequiredIcon />
                                </>
                            }
                            labelColor={errors.cost ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <CurrencyInput
                                renderTextInput={(textInputProps) => (
                                    <FormTextInput
                                        {...textInputProps}
                                        iconName={isActive?"edit":null}
                                        iconType="FontAwesome"
                                        keyboardType="decimal-pad"
                                        style={styles.currencyInput}
                                    />
                                )}
                                placeholder={translate("word", "COST")}
                                disabled={!isActive}
                                value={value}
                                onBlur={onBlur}
                                onChangeValue={onChange}
                                prefix="$"
                                delimiter=","
                                separator="."
                                precision={2}
                                minValue={0}
                                style={isMobile ? styles.fromContainerCurrencyMobile : styles.fromContainerCurrency}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="total_width"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.total_width?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.total_width?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={translate("word", "TOTAL_WIDTH")}
                            labelColor={errors.total_width ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.total_width ? "danger" : ""}
                                disabled={true}
                                returnKeyType="next"
                                style={styles.fromContainer}
                                placeholder={translate("word", "TOTAL_WIDTH")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="total_heigth"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.total_heigth?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.total_heigth?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={translate("word", "TOTAL_HEIGTH")}
                            labelColor={errors.total_heigth ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.total_heigth ? "danger" : ""}
                                disabled={true}
                                returnKeyType="next"
                                style={styles.fromContainer}
                                placeholder={translate("word", "TOTAL_HEIGTH")}
                                value={value}
                                onChangeText={onChange}
                                onBlur={onBlur}
                            />
                        </Field>
                    )}
                />
                {showFolds && (
                    <Controller
                        control={control}
                        name="folds"
                        rules={{ required: true }}
                        style={styles.extrasContainer}
                        render={({ field: { value, onChange, onBlur } }) => (
                            <Field
                                label={
                                    errors.folds?.type === "required"
                                        ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                        : ""
                                }
                                title={translate("word", "FOLDS")}
                                labelColor={errors.folds ? "danger" : undefined}
                                style={isMobile ? styles.formFieldMobile : styles.formField}
                                titleStyle={isMobile && styles.labelMobile}
                                styleInput={isMobile && styles.containerInput}
                            >
                                <FormTextInput
                                    inputType={errors.folds ? "danger" : ""}
                                    disabled={true}
                                    returnKeyType="next"
                                    style={styles.fromContainer}
                                    placeholder={translate("word", "FOLDS")}
                                    value={value}
                                    onChangeText={onChange}
                                    onBlur={onBlur}
                                />
                            </Field>
                        )}
                    />
                )}
                <Controller
                    control={control}
                    name="area"
                    rules={{ required: true }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.area?.type === "required" ? translate("sentence", "PLEASE_ENTER_THIS_FIELD") : ""
                            }
                            title={translate("word", "AREA")}
                            labelColor={errors.area ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <FormTextInput
                                inputType={errors.area ? "danger" : ""}
                                disabled={true}
                                style={styles.fromContainer}
                                placeholder={translate("word", "AREA")}
                                value={value}
                                onChangeText={onChange}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="unit_cost"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.unit_cost?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.unit_cost?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={translate("word", "UNIT_COST")}
                            labelColor={errors.unit_cost ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <CurrencyInput
                                renderTextInput={(textInputProps) => (
                                    <FormTextInput
                                        {...textInputProps}
                                        iconName={isActive?"edit":null}
                                        iconType="FontAwesome"
                                        keyboardType="decimal-pad"
                                        style={styles.currencyInput}
                                    />
                                )}
                                placeholder={translate("word", "UNIT_COST")}
                                disabled={true}
                                value={value}
                                onBlur={onBlur}
                                onChangeValue={onChange}
                                prefix="$"
                                delimiter=","
                                separator="."
                                precision={2}
                                minValue={0}
                                style={isMobile ? styles.fromContainerCurrencyMobile : styles.fromContainerCurrency}
                            />
                        </Field>
                    )}
                />
                <Controller
                    control={control}
                    name="total_cost"
                    rules={{ required: true, pattern: RegularExpressions.DIGITS_FLOAT }}
                    style={styles.extrasContainer}
                    render={({ field: { value, onChange, onBlur } }) => (
                        <Field
                            label={
                                errors.total_cost?.type === "required"
                                    ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                    : errors.total_cost?.type === "pattern"
                                    ? translate("sentence", "PLEASE_ENTER_A_VALID_NUMBER")
                                    : ""
                            }
                            title={translate("word", "TOTAL_COST")}
                            labelColor={errors.total_cost ? "danger" : undefined}
                            style={isMobile ? styles.formFieldMobile : styles.formField}
                            titleStyle={isMobile && styles.labelMobile}
                            styleInput={isMobile && styles.containerInput}
                        >
                            <CurrencyInput
                                renderTextInput={(textInputProps) => (
                                    <FormTextInput
                                        {...textInputProps}
                                        iconName={isActive?"edit":null}
                                        iconType="FontAwesome"
                                        keyboardType="decimal-pad"
                                        style={styles.currencyInput}
                                    />
                                )}
                                placeholder={translate("word", "TOTAL_COST")}
                                disabled={true}
                                value={value}
                                onBlur={onBlur}
                                onChangeValue={onChange}
                                prefix="$"
                                delimiter=","
                                separator="."
                                precision={2}
                                minValue={0}
                                style={isMobile ? styles.fromContainerCurrencyMobile : styles.fromContainerCurrency}
                            />
                        </Field>
                    )}
                />
                {!inCalculator && (
                    <Controller
                        control={control}
                        name="notes"
                        rules={{ required: false, maxLength: 240 }}
                        style={styles.extrasContainer}
                        render={({ field: { value, onChange, onBlur } }) => (
                            <Field
                                label={
                                    errors.notes?.type === "required"
                                        ? translate("sentence", "PLEASE_ENTER_THIS_FIELD")
                                        : errors.notes?.type === "maxLength"
                                        ? translate("sentence", "MAX_LENGTH_240")
                                        : ""
                                }
                                title={translate("word", "NOTES")}
                                labelColor={errors.notes ? "danger" : undefined}
                                style={styles.formField}
                            >
                                <FormTextInput
                                    inputType={errors.notes ? "danger" : ""}
                                    iconName={isActive?"edit":null}
                                    iconType="FontAwesome"
                                    disabled={!isActive}
                                    multiline={true}
                                    returnKeyType="next"
                                    autoCorrect={false}
                                    autoCapitalize="none"
                                    style={styles.fromContainer}
                                    placeholder={translate("word", "NOTES")}
                                    value={value}
                                    onChangeText={onChange}
                                    onBlur={onBlur}
                                />
                            </Field>
                        )}
                    />
                )}
                {!inCalculator && (
                    <FormAdditionals
                        {...{ additionals, setAdditionals, setErrorForm, clearErrors, setTotalAdditional, isActive }}
                    />
                )}
            </FluidView>
            {isActive && !inCalculator && (
                <FormButton
                    buttonType="nummaBlue"
                    disabled={isLoading}
                    isLoading={isLoading}
                    style={styles.formButton}
                    onPress={handleSubmit(props.onSubmit)}
                >
                    {translate("sentence", "SAVE")}
                </FormButton>
            )}
        </FluidView>
    );
};

const styles = StyleSheet.create({
    container100: {
        width: "100%",
        marginTop: "auto",
        marginBottom: "auto",
    },
    formField: {
        marginTop: 10,
    },
    formButton: {
        marginTop: 10,
    },
    extrasContainer: {},
    fromContainer: {
        backgroundColor: Colors.NUMMA_YELLOW,
        width: "100%",
    },
    fromContainerSelect: {
        backgroundColor: Colors.NUMMA_YELLOW,
        width: "100%",
    },
    fromContainerCurrency: {
        backgroundColor: Colors.NUMMA_YELLOW,
        paddingHorizontal: 0,
        paddingTop: 15,
        paddingBottom: 10,
        borderWidth: 1,
        borderRadius: 5,
        fontSize: 18,
        paddingLeft: 15,
    },
    checkBox: {
        justifyContent: "center",
    },
    fromContainerCurrencyMobile: {
        backgroundColor: Colors.NUMMA_YELLOW,
        paddingHorizontal: 0,
        paddingTop: 10,
        paddingBottom: 10,
        borderWidth: 1,
        borderRadius: 5,
        fontSize: 14,
        paddingLeft: 15,
    },
    formFieldMobile: {
        marginVertical: 10,
        flexDirection: "row",
        justifyContent: "space-between",
    },
    fromContainerMobile: {
        width: "100%",
    },
    labelMobile: {
        marginVertical: "auto",
        width: "35%",
    },
    containerInput: {
        width: "65%",
    },
    currencyInput: {
        backgroundColor: Colors.NUMMA_YELLOW,
        paddingRight: 10,
    },
});

export default FromCortina;
